$(document).on('click', '.js-copy', function( e ) {
  e.preventDefault();
  var $a = $(this);
  var copy = $a.data('copy');
  var text = $a.data('copy-text');
  var is_text_replace = $a.hasClass('js-copy-text-replace');
  text = text ? text : Drupal.t('Copied');
  if ( copy ) {
    // Copy to clipboard
    var $i = $('<textarea>');	// Create textarea
    $i.css({
      position: 'absolute',				// Position absolute
      left: '-9999em',					// Off screen by X
      top: $(window).scrollTop() + 100,	// On screen by Y
    });
    $i.prop('readonly',true);	// Readonly
    $i.val(copy);				// Set value to copy
    $('body').append($i);		// Append textarea to <body>
    $i.focus();					// Focus it
    $i.select();				// Select all text in textarea
    var ok = false;
    if ( document.execCommand ( 'copy' )) {	// Copy selection to clipboard
      ok = true;
    }
    $i.remove();				// Remove textarea

    var $w = $a.closest('.js-copy-wrap');

    // Close share if this is share
    if ( $w.hasClass('share-wrap')) {
      $w.find('.share-cta').trigger('click');
    }

    // Show notification
    var $n = $('<div class="js-copy-message"></div>');
    $n.html(ok ? text : Drupal.t('Unable to copy : ('));
    $n.css({display: 'none'});
    $w.append($n);
    $n.fadeIn(300);
    setTimeout(function() {
      $n.fadeOut(1000, function() {
        $n.remove();
      });
    }, 1000);
  }
} );
